/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useRef, useEffect, useCallback } from 'react';
import { PriceList } from './PriceList';
import { BatchList } from './BatchList';
import { CustomerList } from './CustomerList';
import { emptyValidation } from "../../../../../helpers/validation";
import { CustomForm } from './CustomForm';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkViewPermission, capitalizeFirstLetter } from '../../../../../helpers/utilities';
import groupActions from "../../../../Sales/Setup/redux/actions";
import salesActions from "../../../../Sales/Management/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { AESDecrypt, AESEncrypt } from "../../../../../helpers/Crypto";
import { postRequest } from "../../../../../helpers/axiosClient";
import productActions from "../../../../Product/Product/redux/actions";


const BulkPublishPriceList = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { createDetails, createError, createLoader, editLoader, editDetails, editError } = useSelector(state => state.crudReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const [error, setError] = useState({});
    const { history } = props;
    const [form, setForm] = useState({ filterBy: 'ALL', productFilter: 'catalogue' });
    const [visible, setVisible] = useState(false);
    const [view, setView] = useState('batch');
    const [priceList, setPriceList] = useState([]);
    const [publishing, setPublishing] = useState(false);
    const { type } = useParams();
    const { values } = useParams();
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const priceRef = useRef('');
    const batchRef = useRef('');
    const customerRef = useRef('');
    const dispatch = useDispatch();

    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    }

    const emptyState = () => {
        setError({});
    }

    const emptyStateInput = () => {
        setForm({ filterBy: 'ALL', productFilter: 'catalogue' });
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission(`${capitalizeFirstLetter(type)} Price List`, history, 'Admin')) {
                if (type === 'outbound') {
                    loadTasks();
                }
            }
        }
    }, [roleManagement]);


    useEffect(() => {
        if (type !== '') {
            if (values) {
                setForm({ ...AESDecrypt(values) });
                setView('price');
                setTimeout(() => {
                    priceRef?.current?.dispatchFilter(AESDecrypt(values));
                });
                setVisible(false);
            } else {
                batchRef?.current?.dispatchFilter();
            }
        }
    }, [type, values]);

    const loadTasks = useCallback(() => {
        dispatch({
            type: groupActions.CUSTOMERGROUP_DETAILS_START, url: 'customer-group', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: { "and": [{ customerBusinessId: { neq: null } }] }
            },
        });

        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
                where: { "and": [{ status: 'ACTIVE' }] },
                order: 'id  desc'
            }
        });
    });

    const handleCancelProduct = (field) => {
        if (values) {
            let v = AESDecrypt(values);
            history.push(`/admin/batch-process/bulk-publish-price/${AESEncrypt(v.batchId)}/view`);
        } else {
            if (field === 'batch') {
                handleClose();
            }
            setView(field);
            setTimeout(() => {
                if (field === 'batch') {
                    batchRef?.current?.dispatchFilter(type);
                } else if (field === 'price') {
                    priceRef?.current?.dispatchFilter(form);
                }
            });
        }

    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e
            });
        } else {
            if (e.target.name === 'filterBy') {
                setError({});
            }
            setForm({
                ...form,
                [e.target.name]: e.target.value
            });
        }
    }

    const createBatch = (e) => {
        e.preventDefault();
        let group = true;
        let customer = true;
        let emptyGroup = '';
        let emptyCustomer = '';
        if (form.filterBy === 'GROUP') {
            emptyGroup = emptyValidation('Customer Group', form.groupId, 'dropDown');
            group = emptyGroup.isValid;
        } else if (form.filterBy === 'SPECIFIC') {
            emptyCustomer = emptyValidation('Customer', form.customerId, 'dropDown');
            customer = emptyCustomer.isValid;
        }
        if (group && customer) {
            setView('price');
            setTimeout(() => {
                priceRef?.current?.dispatchFilter(form);
            });
            setVisible(false);
        } else {
            setError({
                'groupId': emptyGroup.errors,
                'customerId': emptyCustomer.errors,
            })
        }
    }

    const selectCustomer = () => {
        setView('customer');
        setTimeout(() => {
            customerRef?.current?.dispatchFilter();
        });
    }

    const handlePriceList = (data) => {
        setPriceList(data);
    }

    const chunkArray = (arr = [], size = 10) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
        }
        return chunks;
    };

    const handlePublishConfirm = async (customers, status = 'PUBLISHED') => {
        setPublishing(true);
        const price = priceList && priceList.length ? priceList.map((el) => {
            const copy = { ...el };
            delete copy.product; delete copy.customer; delete copy.unit; delete copy.business;
            return copy;
        }) : [];

        const cus = customers && customers.length > 0 ? customers.map((el) => {
            const copy = { ...el };
            delete copy.area; delete copy.city; delete copy.country; delete copy.currency; delete copy.customerBalance; delete copy.language; delete copy.mop;
            delete copy.group; delete copy.partyGst; delete copy.pincode; delete copy.state;
            return copy;
        }) : [];

        const chunks = chunkArray(price, 200);

        try {
            for (let i = 0; i < chunks.length; i++) {
                const details = {
                    batchAgreements: chunks[i],
                    batchCustomers: cus,
                    inBound: false,
                    isValidate: false,
                    inApp: false,
                    batchStatus: status,
                    isCatalogue: form.productFilter === 'catalogue',
                    filterBy: form.filterBy,
                };

                if (form?.customerId) details['customerName'] = customObject(customerDetails, form?.customerId)?.name;
                if (form?.groupId) details['customerGroup'] = customObject(customerGroupdetails, form?.groupId)?.name;
                if (form?.fromDate) details['fromDate'] = form?.fromDate;
                if (form?.toDate) details['toDate'] = form?.toDate;

                // Send chunk sequentially and wait for success before next
                console.log('Publishing chunk', i + 1, 'of', chunks.length);
                console.log('Publishing chunk', chunks[i]);
                await postRequest('batches', details);
            }

            toast.dismiss();
            toast.success('All batches published successfully');
            setView('batch');
            setTimeout(() => {
                batchRef?.current?.dispatchFilter(type);
            });
            setPublishing(false);
        } catch (error) {
            toast.dismiss();
            const message = error?.response?.data?.message || error?.message || 'Failed to publish batch';
            toast.error(message);
            setPublishing(false);
        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => el.id === id);
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            toast(createDetails);
            setView('batch');
            setTimeout(() => {
                batchRef?.current?.dispatchFilter(type);
            });
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(editDetails);
            setView('batch');
            setTimeout(() => {
                batchRef?.current?.dispatchFilter(type);
            });
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);




    return (
        <React.Fragment>
            {
                view === 'batch' ? <BatchList type={type} ref={batchRef} handleOpen={() => handleOpen()}
                    handleClose={() => handleClose()}
                    {...props}
                /> : <>
                    {
                        view === 'price' ? <PriceList customObject={(deatils, id) => customObject(deatils, id)} {...props}
                            handleSelectCustomer={() => selectCustomer()}
                            view={'price'}
                            changeHandler={(e, name) => changeHandler(e, name)}
                            handlePriceList={(list) => handlePriceList(list)}
                            handleClose={(type) => handleCancelProduct(type)}
                            type={type}
                            ref={priceRef} form={form}
                        /> : <CustomerList {...props} type={type} loader={publishing || createLoader || editLoader} handleClose={(type) => handleCancelProduct(type)}
                            ref={customerRef} form={form}
                            handlePublishConfirm={(customers, status = 'PUBLISHED') => handlePublishConfirm(customers, status)}
                        />
                    }
                </>
            }
            <CustomForm
                customObject={(details, id) => customObject(details, id)}
                visible={visible}
                handleClose={() => handleClose()}
                createBatch={(e) => createBatch(e)}
                changeHandler={(e, name) => changeHandler(e, name)}
                form={form}
                error={error}
                customerDetails={customerDetails}
                customerGroupdetails={customerGroupdetails}

            />
        </React.Fragment>
    );
}

export default BulkPublishPriceList;